(function () {

    'use strict';

    angular
        .module('app.contactus')
        .directive('contactUs', [function () {
            return {
                restrict: 'E',
                templateUrl: 'app/contactus/ContactUs.html'
            }
        }]);

})();


// WEBPACK FOOTER //
// ./app/contactus/ContactUsDirective.js